import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { TranslateService } from "@ngstack/translate";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { CourseService } from "src/app/services/http/business/course/course.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ErrorsService } from "src/app/services/common/errors.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-send-sms',
  templateUrl: './send-sms.component.html',
  styleUrls: ['./send-sms.component.css']
})
export class SendSmsComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  errors = new Array();

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    private courseService: CourseService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private DialogRef: MatDialogRef<SendSmsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    console.log(this.data);

    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      StudentNationalCode: [this.data && this.data.StudentNationalCode ? this.data.StudentNationalCode : null],
      CourseId: [this.data && this.data.CourseId ? this.data.CourseId : null],
      CoursePatternId: [this.data && this.data.CoursePatternId ? this.data.CoursePatternId : null],
      TermInfoId: [this.data && this.data.TermInfoId ? this.data.TermInfoId : null],
      BranchEncryptId: [this.data && this.data.BranchEncryptId ? this.data.BranchEncryptId : null],
      Message: [null, Validators.compose([Validators.required])]
    });
  }

  submit(data: any) {
    console.log(data);
    let confirm: IConfirm = {
      accept: true,
      message: 'آیا از ارسال پیام پیام اطمینان دارید؟',
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (data.StudentNationalCode) {
          let sendSMSCommand = {
            NationalCode: data.StudentNationalCode,
            Message: data.Message
          }
          this.courseService.SendSMSToPerson(sendSMSCommand).subscribe(() => {
            this.snackBar.OpenSnackBar(
              'پیام با موفقیت ارسال شد',
              "OK",
              5000,
              SoundEnum.beep
            );
          }, err => {
            // this.errObject = this.errorService.getError(err);
            // this.param = this.errorService.objectError(this.errObject);
            // this.errors = this.errorService.returnError(err);
            this.errorList = this.errorService.getErrorList(err.error)
          })
        }
        else if (data.CourseId) {
          let sendSMSCommand = {
            CourseId: data.CourseId,
            Message: data.Message
          }
          this.courseService.SendSMSToClass(sendSMSCommand).subscribe(() => {
            this.snackBar.OpenSnackBar(
              'پیام با موفقیت ارسال شد',
              "OK",
              5000,
              SoundEnum.beep
            );
          }, err => {
            // this.errObject = this.errorService.getError(err);
            // this.param = this.errorService.objectError(this.errObject);
            // this.errors = this.errorService.returnError(err);
            this.errorList = this.errorService.getErrorList(err.error)
          })
        }
        else if (data.CoursePatternId && data.TermInfoId && data.BranchEncryptId) {
          let sendSMSCommand = {
            CoursePatternId: data.CoursePatternId,
            BranchEncryptId: data.BranchEncryptId,
            TermInfoId: data.TermInfoId,
            Message: data.Message
          }
          this.courseService.SendSMSToPattern(sendSMSCommand).subscribe(() => {
            this.snackBar.OpenSnackBar(
              'پیام با موفقیت ارسال شد',
              "OK",
              5000,
              SoundEnum.beep
            );
          }, err => {
            // this.errObject = this.errorService.getError(err);
            // this.param = this.errorService.objectError(this.errObject);
            // this.errors = this.errorService.returnError(err);
            this.errorList = this.errorService.getErrorList(err.error)
          })
        }
      }
    });
  }

  closeModal() {
    this.DialogRef.close();
  }

}
